import type { OPSUserRoleVO } from "@/api/accounts/type";
import { cn } from "@/lib/cn";

import { getOpsUserRoleKey } from "../../../utils";

/** 角色切换按钮组 props */
interface RoleSelectorProps {
  /** 当前组织下的角色列表 */
  roles: OPSUserRoleVO[];
  /** 当前选中的角色 */
  selectedRole: OPSUserRoleVO | null;
  /** 切换角色回调 */
  onSelect: (role: OPSUserRoleVO) => void;
}

/**
 * 身份权限右侧顶部角色切换按钮
 * 默认选中第一个，支持在同一组织下切换角色
 */
export const RoleSelector = ({ roles, selectedRole, onSelect }: RoleSelectorProps) => {
  if (roles.length === 0) return null;
  return (
    <div className="flex items-center gap-2 px-4 pt-4 pb-2 border-b border-slate-100 shrink-0 flex-wrap">
      {roles.map((role) => {
        const roleKey = getOpsUserRoleKey(role);
        const isActive = selectedRole ? getOpsUserRoleKey(selectedRole) === roleKey : false;
        const isEnabled = role.status === "ENABLED";
        return (
          <button
            key={roleKey}
            type="button"
            className={cn(
              "px-4 py-1.5 rounded-md text-sm font-medium transition-all border",
              isActive
                ? "bg-orange-500 text-white border-orange-500 shadow-sm"
                : "bg-white text-orange-600 border-orange-200 hover:bg-orange-50",
              !isEnabled && "opacity-50",
            )}
            onClick={() => onSelect(role)}
          >
            {role.roleName}
          </button>
        );
      })}
    </div>
  );
};
